export default {
    SHIPMENT_STOPS_DATA_FETCH_SUCCESS: 'SHIPMENT_STOPS_DATA_FETCH_SUCCESS',
    SHIPMENT_TRACKING_DATA_FETCH_SUCCESS: 'SHIPMENT_TRACKING_DATA_FETCH_SUCCESS',
    SHIPMENT_STOPS_DATA_FETCH_FAILED: 'SHIPMENT_STOPS_DATA_FETCH_FAILED',
    SHIPMENT_TRACKING_DATA_FETCH_FAILED: 'SHIPMENT_TRACKING_DATA_FETCH_FAILED',
    SHIPMENT_LOADING: 'SHIPMENT_LOADING',
    STOPS_DETAILS: 'STOPS_DETAILS',
    TRACKING_DETAILS: 'TRACKING_DETAILS'
}